export const DEFAULT_DOCUMENT_TITLE = "DMS";
export const MAIL_INBOX_DOCUMENT_TITLE = "Mail Inbox";

const ROUTE_DOCUMENT_TITLES = [
  [/^\/home(?:\/|$)/, "Dashboard"],
  [/^\/matter(?:\/|$)/, "Matters"],
  [/^\/notifications(?:\/|$)/, "Notifications"],
  [/^\/search(?:\/|$)/, "Search"],
  [/^\/review(?:\/|$)/, "Review Queue"],
  [/^\/mail-intake(?:\/|$)/, "Mail Intake"],
  [/^\/fee-notices(?:\/|$)/, "Fee Notice Review"],
  [/^\/fax(?:\/|$)/, "Fax"],
  [/^\/brief-bank(?:\/|$)/, "Brief Bank"],
  [/^\/articles-bank(?:\/|$)/, "Articles Bank"],
  [/^\/help(?:\/|$)/, "Help"],
  [/^\/settings(?:\/|$)/, "Settings"],
];

const cleanTitle = (value) => {
  const title = typeof value === "string" ? value.trim() : "";
  return title || null;
};

const getMatterId = (matter) =>
  matter?.id ??
  matter?.matter_id ??
  matter?.sf_matter_id ??
  matter?.sf_id ??
  matter?.matterId ??
  null;

const getMatterName = (matter) =>
  cleanTitle(
    matter?.display_name ||
      matter?.matter_displayName ||
      matter?.matter_display_name ||
      matter?.client_name ||
      matter?.name
  );

const getRouteMatterId = (pathname) => {
  const match = String(pathname || "").match(/^\/matter\/([^/?#]+)/i);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
};

const isSameIdentifier = (left, right) =>
  left != null && right != null && String(left) === String(right);

export const getDocumentTitle = ({
  pathname = "",
  matter = null,
  locationState = null,
} = {}) => {
  if (/^\/inbox(?:\/|$)/i.test(pathname)) {
    return MAIL_INBOX_DOCUMENT_TITLE;
  }

  const routeMatterId = getRouteMatterId(pathname);
  if (routeMatterId) {
    const matterName = cleanTitle(locationState?.matterName);
    if (matterName) return matterName;

    if (isSameIdentifier(getMatterId(matter), routeMatterId)) {
      return getMatterName(matter) || "Matter";
    }

    return "Matter";
  }

  const routeTitle = ROUTE_DOCUMENT_TITLES.find(([pattern]) =>
    pattern.test(pathname)
  );
  return routeTitle?.[1] || DEFAULT_DOCUMENT_TITLE;
};
